"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateMnemonic = exports.keychain = void 0;
const asteroid_sdk_js_1 = require("@moonlight-io/asteroid-sdk-js");
exports.keychain = new asteroid_sdk_js_1.Keychain();
function generateMnemonic() {
    exports.keychain.generateMnemonic(128);
    if (!exports.keychain.mnemonic)
        throw new Error('Failed to generate mnemonic');
    return exports.keychain.mnemonic.toString().split(' ');
}
exports.generateMnemonic = generateMnemonic;
